import { render, staticRenderFns } from "./Permissions_for_Fusebox_Adjustments.vue?vue&type=template&id=8c78880e"
import script from "./Permissions_for_Fusebox_Adjustments.vue?vue&type=script&lang=js"
export * from "./Permissions_for_Fusebox_Adjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports